module.exports = __webpack_public_path__ + "img/3.f03d570a.jpg";